<template>
  <a
    :href="coupon.cpu"
    target="_blank"
    class="site-item"
  >
    <div class="item-wrap">
      <div class="item-img">
        <img
          class="lazy"
          :src="defaultImg"
          :data-src="getCouponImage(coupon.pi)"
          :alt="`${coupon.pn}`"
        />
      </div>
      <div class="item-txt">
        <div class="item-name">{{ coupon.pn }}</div>
        <p class="item-desc">{{ coupon.cpn }}</p>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: ["coupon", "translations"],
  data() {
    return {
      defaultImg:
        "https://www.fantasygully.com/static-assets/images/cssimages/default-lazy-square.png",
    };
  },
  methods: {
    getCouponImage(img) {
      return `https://www.fantasygully.com/static-assets/roi/images/pf/${img}`;
    },
  },
};
</script>